class StickyAtc extends HTMLElement {
  constructor() {
      super()

      this.productInfo    = document.querySelector('[x-data="productForm"] .product-form__wrap')
      this.atcImage       = this.querySelector('[data-atc-image]')
      this.atcVariant     = this.querySelector('[data-atc-variant]')
      this.atcPrice       = this.querySelector('[data-atc-price]')
      this.atcButton      = this.querySelector('[data-atc-button]')
      this.klaviyoTeaser  = this.querySelector('.kl-teaser-QWadqi')
      this.quantityInput  = this.querySelector('input[name="quantity"]')
      this.footer         = document.querySelector('.newsletter-section') ? document.querySelector('.newsletter-section') : document.querySelector('footer-block')
      
  }

  connectedCallback() {
      document.addEventListener('variant-changed', this.onVariantChange.bind(this));
    
      const toggleSticky = () => {
        if (!this.productInfo) return;
    
        const rect = this.productInfo.getBoundingClientRect();
    
        // Show only after the original ATC/form has scrolled above the header area
        const isPastAtc = rect.bottom <= 132;

        // Hide when scrolled past footer
        const isPastFooter = this.footer.getBoundingClientRect().top <= 100;
    
        this.classList.toggle('active', isPastAtc && !isPastFooter);
        document.body.classList.toggle('sticky-active', isPastAtc && !isPastFooter);
      };
    
      window.addEventListener('scroll', toggleSticky, { passive: true });
      window.addEventListener('resize', toggleSticky);
      toggleSticky();
    
      const addToCart = new CustomEvent('add-to-cart', { bubbles: true });
    
      const quantityChange = (quantity) =>
        new CustomEvent('quantity-change', {
          bubbles: true,
          detail: { quantity },
        });
    
      this.atcButton.addEventListener('click', () => {
        document.dispatchEvent(addToCart);
      });
    
      document.addEventListener('quantity-change', (e) => {
        this.quantityInput.value = e.detail.quantity;
      });
    
      this.quantityInput.addEventListener('change', (e) => {
        document.dispatchEvent(quantityChange(Number(e.target.value)));
      });
    }

  onVariantChange(e) {
      if (window.variantImages[e.detail.variant.id]) {
          this.atcImage.src = window.variantImages[e.detail.variant.id]
      } else if (window.productImage) {
          this.atcImage.src = window.productImage
      } else {
          return;
      }

      this.atcVariant.textContent = e.detail.variant.title === 'Default Title'? '' : e.detail.variant.title
  }

  formatMoney(price) {
      return (price/100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
      });
  }

}

customElements.define('sticky-atc', StickyAtc)
